import type { ClaimableReward } from '../ui/types';

import type { BattleClosing } from './types';

/**
 * The prize the closing pane claims and animates, or null when its CTA only acknowledges.
 *
 * `CLAIM` needs both core's `claimable` and a reward that actually carries something — an all-zero
 * prize is treated as nothing to claim, as the tournament finish popup does. Missing coin amounts
 * normalise to 0 and missing bundle items to [] so the result feeds `startAnimation` directly.
 */
export function selectClosingReward(closing: BattleClosing): ClaimableReward | null {
  const { reward } = closing;

  if (!closing.claimable || !reward) {
    return null;
  }

  const bundleItems = reward.bundleItems ?? [];

  return reward.gcCoin || reward.scCoin || bundleItems.length > 0
    ? { gcCoin: reward.gcCoin || 0, scCoin: reward.scCoin || 0, bundleItems }
    : null;
}
